import AboutTheWorldWrapper from '@/layouts/AboutTheWorldWrapper'

import PageNotFound from '@/pages/PageNotFound'

const AboutTheWorld = () => import('@/pages/AboutTheWorld')
const LafoRiver = () => import('@/pages/about-theha/LafoRiver')

const childrenRoutes = [
	{
		path     : '/',
		name     : 'About Theha',
		component: AboutTheWorld
	},
	{
		path     : 'lafo-river',
		name     : 'Lafo River',
		component: LafoRiver
	}
]

childrenRoutes.forEach(route => {
	if (route.meta === undefined) route.meta = {}
	route.meta.area = 'about-theha'
})

childrenRoutes.push({ path: '*', component: PageNotFound })

export default {
	path     : '/about-theha',
	component: AboutTheWorldWrapper,
	children : childrenRoutes
}
